function IconHome()
{
    return (
        <div className="md:flex justify-around items-center flex-wrap px-20 gap-5 hidden">
            <img src="/img/axon-baru.png" alt="" className="md:w-[17%] lg:w-[12%]" />
            <img src="/img/jetstar-baru.png" alt="" className="md:w-[17%] lg:w-[12%]" />
            <img src="/img/expedia-baru.png" alt="" className="md:w-[17%] lg:w-[12%]" />
            <img src="/img/qantas-baru.png" alt="" className="md:w-[17%] lg:w-[12%]" />
            <img src="/img/alitalia.png" alt="" className="md:w-[17%] lg:w-[12%]" />
        </div>
    )
}

export default IconHome;